import { Link } from 'react-router-dom'; 
import { useSelector } from 'react-redux';
 import paths from '../../routes/paths' 
//import Product from './Product'
import MetaTags from '../Common/MetaTags';
import KurtisProduct from '../Womens/Product';
import SareesProduct from './Product';
const  HotDeals = () => {   
  const {hotDeals} = useSelector((state:any) => state.settings)
 
  return (

    <>
     <MetaTags
        title="Hot Deals on Sarees & Kurtis | Anuugha Collections"
        description="Don't miss our hot deals on sarees and kurtis. Enjoy discounts and special offers at Anuugha Collections."
        url="https://www.anuughacollections.com/limited-time-offers"
        image={process.env.REACT_APP_SERVER_URL + ( hotDeals[0]?.variants[0].variant_images[0]?.display_image_url)}
      />
      
      <div className="page-content bg-light">

        <div className="dz-bnr-inr bg-secondary overlay-black-light bannerBG" >
          <div className="container">
            <div className="dz-bnr-inr-entry">
              <h1>Hot Deals</h1>
              <nav aria-label="breadcrumb" className="breadcrumb-row">
                <ul className="breadcrumb">
                  <li className="breadcrumb-item"><Link to={paths.store} className=" menu-title ">Home</Link></li>
                  <li className="breadcrumb-item">Hot Deals</li>
                </ul>
              </nav>
            </div>
          </div>	
        </div>

        <section className="content-inner-3 pt-3 z-index-unset">
          <div className="container-fluid">
            <div className="row">
                <div className="col-80 col-xl-9">
                
                
                <div className="row">
                  <div className="col-12 tab-content shop-" id="pills-tabContent">
                    <div className="tab-pane fade active show" id="tab-list-grid" role="tabpanel" aria-labelledby="tab-list-grid-btn">
                      <div className="row gx-xl-4 g-3">
                          {hotDeals && hotDeals.map((product,index) => 
                            <>
                                {product.subcategory.name === "Sarees" && <SareesProduct product={product} index={index} key={index} />} 
                                {product.subcategory.name !== "Sarees" && <KurtisProduct product={product} index={index} key={index} /> }
                            </>
                          )}
                          
                        </div> 
                    </div>
                  </div>
                </div>
                
                <div className="row page mt-0">
                  
                  <div className="col-md-6">
  
                    {hotDeals.length === 0 && 
                              
                              <div className="col-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 m-md-b15 m-b30">
                                  <div className="shop-card style-1">No Products.</div>
                              </div>
                            }
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="container">              
                  <section className="bg0 p-t-60 p-b-15 app-content category-content">
                      <div className="container">
                          <div className="p-b-10 header">
                              <h1 className="">Anuugha Collections Offers: Embrace Elegance at Unbeatable Prices!</h1>
                          </div>
                          <div className="content">
                              <p>Welcome to Anuugha Collections, where luxury meets affordability. Our exclusive offers bring you a golden opportunity to enhance your wardrobe with timeless elegance. Dive into the world of exquisite fashion and discover the allure of Anuugha sarees at prices that will leave you delighted.</p>
                              <h2>Explore Our Exclusive Saree Offers:                </h2>
                              <ul>
                                  <li>
                                      <b>Limited-Time Discounts:  </b> 
                                      <p>Uncover the magic of Anuugha sarees with our limited-time discounts. From traditional silk sarees to contemporary designs, find the perfect piece to elevate your style.</p>
                                      
                                  </li>
                                  <li>
                                      <b>Special Collections</b> 
                                      <p>Our curated special collections are designed to captivate every occasion. Whether it's a wedding, festival, or a special event, Anuugha Collections offers a saree for every celebration.</p> 
                                  </li>
                                  <li>
                                      <b> New Arrivals:</b>
                                      <p>Stay ahead of the fashion curve with our latest arrivals. Explore fresh designs, vibrant colors, and quality craftsmanship, all at special introductory prices.</p> 
                                  </li>
                                  <li>
                                      <b>Explore Exclusive Deals:</b>
                                      <p>Discover a curated selection of sarees that blend tradition with modern allure. Our offers bring you unparalleled savings on handpicked collections, each piece a testament to craftsmanship and heritage. Whether you're attending a celebration or just want to embrace your cultural roots, Anuugha Collections has the perfect ensemble for you.</p> 
                                  </li>
                              </ul>
                                  
                                  <h2>How to Avail Offers:</h2>
                              <ul>
                                  <li>
                                      Browse our Offers Page and explore the stunning bunch of sarees with offer price.

                                  </li>
                                  <li>
                                      Select your favorite saree and add them to your cart.
                                  </li>
                                  <li>
                                      Make a payment – it's that simple!
                                  </li> 
                              </ul>
                              <h2>Shop Now and Redefine Your Style:</h2>
                              <p>Don't miss out on these exclusive offers. Elevate your wardrobe with Anuugha Collections sarees that speak volumes about your style and grace. Shop now, and let the allure of timeless elegance embrace you.</p>
                              <p>At Anuugha Collections, it's not just about fashion; it's about making a statement. Experience luxury without compromise. Browse our offers now!</p>
                          </div>
                      </div>
                  </section>
              </div>
        </section>  
      </div>
    </> 
  );
}

export default HotDeals;

 
